export const ELEMENT_CODE_BLOCK = 'code_block';

export const ELEMENT_CODE_LINE = 'code_line';

export const ELEMENT_CODE_SYNTAX = 'code_syntax';
